import { render, staticRenderFns } from "./customer-detail-message.vue?vue&type=template&id=4393527e&"
import script from "./customer-detail-message.vue?vue&type=script&lang=js&"
export * from "./customer-detail-message.vue?vue&type=script&lang=js&"
import style0 from "./customer-detail-message.vue?vue&type=style&index=0&module=true&lang=less&"
import style1 from "./customer-detail-message.vue?vue&type=style&index=1&lang=less&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports